<template>

  <b-form @submit="onSubmit" autocomplete="off">
    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.email')" label-for="email">
      <b-form-input id="email" :disabled="disableUsername" v-model="user.email" @blur="checkUsername" :placeholder="$t('users.enter-email')" autocomplete="new-password"></b-form-input>
    </b-form-group>
    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.enterprise-name')" label-for="enterpriseName">
      <b-form-input id="enterpriseName" v-model="user.enterpriseName" :placeholder="$t('users.enter-enterprise-name')"></b-form-input>
    </b-form-group>
    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.enter-enterprise-short-name')" label-for="enterpriseShortName">
      <b-form-input id="enterpriseShortName" v-model="user.enterpriseShortName" :placeholder="$t('users.enterprise-short-name')"></b-form-input>
    </b-form-group>
    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.password')" label-for="password1">
      <b-form-input id="password1" v-model="password" type="password" :placeholder="$t('users.enter-password')" autocomplete="new-password"></b-form-input>
    </b-form-group>
    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.repeated-password')" label-for="password2">
      <b-form-input id="password2" v-model="repeatedPassword" type="password" :placeholder="$t('users.enter-repeated-password')"></b-form-input>
    </b-form-group>
    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.roles')">
      <div v-if="myRoles" class="mt-2">
        <b-overlay :show="rolesOverlay" spinner-small>
          <div v-if="user.role">
            <b-form-radio-group id="radio-group-1" v-model="user.role.id" :options="myRolesOptions" name="role" @change="changeRole()"></b-form-radio-group>
          </div>
          <div v-else>
            <b-form-radio-group id="radio-group-1" v-model="selectedUserRole" :options="myRolesOptions" name="role" @change="changeRole()"></b-form-radio-group>
          </div>
        </b-overlay>
      </div>
    </b-form-group>
    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.country')" label-for="country">
      <b-form-input id="country" list="country-list" v-model="user.country" :placeholder="$t('users.enter-country')" autocomplete="off"></b-form-input>
      <datalist id="country-list">
        <option v-for="country in contryList" :key="country">{{ country }}</option>
      </datalist>
    </b-form-group>
    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.image')" label-for="image">
        <div v-if="user.logo !== null || user.logo !==''">
          <b-row class="my-2">
            <b-col lg="6">
              <b-img thumbnail fluid :src="user.logo" id="thumbnail"></b-img>
            </b-col>
            <b-col lg="6">
              <b-form-file :browse-text="$t('users.choose-logo')" :placeholder="$t('users.no-logo-selected')" v-model="imageFile" @input="showImage" accept="image/jpeg, image/png, image/gif" id="imageFile"></b-form-file>
              <div v-if="imageFile != null">
              <h5>Image data</h5>
              <p style="word-wrap: break-word;"><strong>Name: </strong>{{ imageFile.name }}</p>
              <p><strong>Size: </strong>{{ this.getFileSize(imageFile.size) }}</p>
              <p><strong>Date: </strong>{{ dateTime(imageFile.lastModifiedDate, 'long') }}</p>
            </div>
            </b-col>
          </b-row>
        </div>
        <div v-else>
        <b-form-file :browse-text="$t('users.choose-logo')" :placeholder="$t('users.no-logo-selected')" v-model="imageFile" @input="showImage" accept="image/jpeg, image/png, image/gif" id="imageFile"></b-form-file>
        <b-row class="my-2"  v-show="imageFile != null">
          <b-col lg="6">
            <b-img thumbnail fluid src="" id="thumbnail"></b-img>
          </b-col>
          <b-col lg="6">
            <div v-if="imageFile != null">
              <h5>Image data</h5>
              <p style="word-wrap: break-word;"><strong>Name: </strong>{{ imageFile.name }}</p>
              <p><strong>Size: </strong>{{ this.getFileSize(imageFile.size) }}</p>
              <p><strong>Date: </strong>{{ dateTime(imageFile.lastModifiedDate, 'long') }}</p>
            </div>
          </b-col>
        </b-row>
        </div>
    </b-form-group>

    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.website')" label-for="website">
      <b-form-input id="website" v-model="user.webSite" :placeholder="$t('users.enter-website')"></b-form-input>
    </b-form-group>
    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.contact-person')" label-for="contactPerson">
      <b-form-input id="contactPerson" v-model="user.contactPerson" :placeholder="$t('users.enter-contact-person')"></b-form-input>
    </b-form-group>
    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.contact-person-email')" label-for="contactPersonEmail">
      <b-form-input id="contactPersonEmail" v-model="user.contactEmail" :placeholder="$t('users.enter-contact-person-email')"></b-form-input>
    </b-form-group>
    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.contact-person-phone')" label-for="contactPersonPhone">
      <b-form-input id="contactPersonPhone" v-model="user.contactPhone" :placeholder="$t('users.enter-contact-person-phone')"></b-form-input>
    </b-form-group>

    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.note')" label-for="note">
      <b-form-textarea id="note" v-model="user.note" :placeholder="$t('users.enter-note')" rows="4"></b-form-textarea>
    </b-form-group>

    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.enabled')" label-for="enabled">
      <b-form-checkbox id="enabled" v-model="user.enabled" name="check-button" size="lg" switch>
        <small v-if="user.enabled">
          {{$t('users.userIsEnabled')}}
        </small>
        <small v-else>
          {{$t('users.userIsNotEnabled')}}
        </small>
      </b-form-checkbox>
    </b-form-group>

    <b-form-group label-cols-sm="12" label-cols-md="4" :label="$t('users.langauge')" label-for="language">
      <div v-if="myLanguages">
        <b-overlay :show="languagesOverlay" spinner-small>
          <div v-if="user.language">
            <b-form-input @change="changeLang()" id="language" list="language-list" v-model="user.language.name" :placeholder="$t('users.choose-language')" autocomplete="off"></b-form-input>
          </div>
          <div v-else>
            <b-form-input @change="changeLang()" id="language" list="language-list" v-model="langName" :placeholder="$t('users.choose-language')" autocomplete="off"></b-form-input>
          </div>
          <datalist id="language-list">
            <option v-for="lang in myLanguages" :key="lang.id">{{ lang.name }}</option>
          </datalist>
        </b-overlay>
      </div>
    </b-form-group>

    <b-form-group label-cols-sm="12" label-cols-md="4">
      <b-overlay :show="saveSpinner" spinner-small spinner-variant="secondary" opacity="0.5" class="d-inline-block">
        <b-button :disable="saveSpinner" type="submit" variant="primary">{{ $t('users.save-user')}}</b-button>
      </b-overlay>
    </b-form-group>
  </b-form>
</template>

<script>
import { BForm, BFormTextarea, BFormFile, BImg, BFormCheckbox, BFormRadioGroup } from 'bootstrap-vue'

export default {
  name : "UserForm",
  components : {BForm, BFormTextarea, BFormFile, BImg, BFormCheckbox, BFormRadioGroup},
  props: {
    user: Object
  },
  data : function() {
    return {
      password: "",
      repeatedPassword: "",
      imageFile: null,
      languages: [],
      langName: "",
      languagesOverlay: true,
      contryList: ["Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, The Democratic Republic of the", "Cook Islands", "Costa Rica", "Cote D'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and Mcdonald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran, Islamic Republic Of", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Democratic People's Republic of Korea", "Korea, Republic of", "Kosovo", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Macedonia, The Former Yugoslav Republic of", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestinian Territory, Occupied", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Viet Nam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"],
      roles: {},
      rolesOptions: [],
      rolesOverlay: true,
      selectedUserRole: {},
      saveSpinner : false
    }
  },

  created: async function() {
    await this.$http.get("/cms/api/languages/all", { headers: {Authorization: this.getAuthData().accessToken }})
      .then(r => {
        this.languages = r.data;
        this.languagesOverlay = false;
      })
      .catch(e => {
        var message = this.handleError(e);
    })
    await this.$http.get("/cms/api/users/roles/all", { headers: {Authorization: this.getAuthData().accessToken }})
      .then(r => {
        const roles = r.data;
      //  console.log(roles);
        var roleOptions = [];
        for (var i = 0; i < roles.length; i++) {
          var role = roles[i];
          roleOptions[i] = { text : role.name, value : role.id }
        }
        this.rolesOptions = roleOptions;
        this.roles = roles;
        this.rolesOverlay = false;
        //console.log(roleOptions);
      }).catch(e => {
        var message = this.handleError(e);
    })
  },
  computed: {
    disableUsername: function() {
      //console.log(this.user);
      if (typeof this.user !== "undefined") {
        if (typeof this.user.email !== "undefined") {
          return true;
        }
      }
      return false;
    },

    myUser: function() {
      return this.user;
    },

    myLanguages: function() {
      return this.languages ? this.languages : null;
    },

    myRoles: function() {
      return this.roles ? this.roles : null;
    },

    myRolesOptions: function() {
      return this.rolesOptions ? this.rolesOptions : null;
    },

    myRolesOverlay: function() {
      //console.log(this.myRoles.length === 0);
      return this.myRoles.length === 0;
    }

  },

  methods : {
    checkUsername: function(e) {
      //console.log(this.user.email);
    },
    changeLang: function(e) {
      const selectedLanguage = this.user.language ? this.user.language.name : this.langName;
      for (var index in this.languages) {
        if (this.languages[index].name === selectedLanguage) {
          this.user.language = this.languages[index];
        }
      }
    },

    changeRole: function() {
      // console.log("Menjam ulogu!"); console.log(this.myUser);
      const selectedRole = this.myUser.role ? this.myUser.role.id : this.selectedUserRole;

      // console.log(selectedRole);
      for (var i in this.roles) {
        // console.log(this.roles[i].id)
        // console.log(this.roles[i].id === selectedRole);
        if (this.roles[i].id === selectedRole) {
          this.user.role = this.roles[i]
        }
      }
    },

    onSubmit: function(event) {
      event.preventDefault();
      this.saveSpinner = true;
      this.user.password = this.password;
      this.user.repeatedPassword = this.repeatedPassword;
      // console.log(this.myUser);

      const data = new FormData();
      // Tekstualne podatke šaljemo kao binarni objekat
      data.append("userForm", new Blob([JSON.stringify(this.myUser)], {type: "application/json"}));
      data.append("image", document.getElementById("imageFile").files[0]);
      const axiosConfig = {
        headers: {"Content-Type": undefined, Authorization: this.getAuthData().accessToken}
      };
      this.$http.post("/cms/api/users/sign-up", data, axiosConfig)
        .then(r => {
					if (r.data === "OK") {
            // Superadministrator ide na Dashboard, a Administrator na Videos
            const loggedUser = this.$root.user;
            if (loggedUser.role.name === "SuperAdministrator") {
              this.$router.push({name : 'Users'});
            } else {
              window.localStorage.setItem("dmn_user", this.encodeJSON(this.user));
              this.$router.push({ name: 'Dashboard' });
            }
					}
        }).catch(error => {
            this.handleError(error);
        })
        this.saveSpinner = false;
    },
    showImage: function (e) {
      var img = document.getElementById("thumbnail");
      this.showMyImage(this.imageFile, img);
    }
  }
}
</script>
<style></style>
